import { Button } from '@root/components'
import nojaRahoitusImgSrc from '@assets/noja/noja-rahoitus-logo.png'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
const NojaThankYou = () => {
  const history = useHistory()
  const [t] = useTranslation()

  return (
    <StyledPageContent>
      <LogoContainer>
        <StyledImg src={nojaRahoitusImgSrc} alt="Noja Rahoitus" />
      </LogoContainer>

      <StyledText>{t('nojaPage.thankYou.body')}</StyledText>

      <Footer>
        <Button intent="success" onClick={() => history.goBack()}>
          {t('nojaPage.thankYou.button')}
        </Button>
      </Footer>
    </StyledPageContent>
  )
}

export default NojaThankYou

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding: ${({ theme }) => theme.spacing.md}rem;
`

const StyledText = styled.p`
  text-align: center;
  max-width: 500px;
  margin: 0;
`

const StyledPageContent = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 }
})`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  max-height: 500px;
  max-width: 800px;
  padding: ${({ theme }) => theme.spacing.md}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
  overflow: auto;

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 100%;
  }
`

const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5.12rem; // Using the logo's letter heigth (64%) in the logo to determine the padding
  box-sizing: border-box;
`

const StyledImg = styled.img`
  width: auto;
  height: 8rem;
`
